import React from 'react';
import { CoreModuleStatus } from "../../models/CoreModels";
import * as Helper from '../../util/Helper';
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';


interface ModuleStatusProps {
    status?: CoreModuleStatus
    displayQuarantine: boolean
    runnable: boolean
}

const ModuleSyncStatus = (props: ModuleStatusProps) => {
    const { t } = useTranslation(['common', 'configuration']);
    const { status } = props;

    if (!props.runnable) {
        return <p>{t('moduleStatus.notRunnable', { ns: 'configuration' })}</p>
    }

    if (status) {
        var isRunning = status.startedAt && !status.completedAt;
        if (status.isInQuarantine) {
            if (props.displayQuarantine) {
                return <p><span className="margin-right1"><FontAwesomeIcon icon="circle-radiation" className="icon icon_critical" /></span>{t('modules.status.quarantineTitle', { ns: 'common' })}. {t('modules.latestActivityAt', { ns: 'common' })}: {Helper.formatDate(status.completedAt)}</p>
            }
            return <p>{t('modules.latestActivityAt', { ns: 'common' })}: {Helper.formatDate(status.completedAt)}</p>
        } else if (isRunning) {
            return <p><span className="margin-right1"><FontAwesomeIcon icon="sync-alt" className="icon green" /></span>{t('modules.latestActivityAt', { ns: 'common' })}: {Helper.formatDate(status.latestActivityAt)}</p>
        } else if (status.isStartRequested) {
            return <p><span className="margin-right1"><FontAwesomeIcon icon="sync-alt" className="icon green" /></span>{t('modules.starting', { ns: 'common' })}</p>
        } else if (status.completedAt) {
            return <p>{t('modules.lastRun', { ns: 'common' })}: {Helper.formatDate(status.completedAt)}</p>
        }
    }
    return <p>{t('modules.latestActivityAt', { ns: 'common' })}: {t('modules.activityMissing', { ns: 'common' })}</p>
}

export default ModuleSyncStatus; 
